const mutations = {
  SET_OBJ_USUARIO(state, value) {
      state.obj_usuario = value;
  }
};
export default mutations;